import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';
import ShopList from '../../../components/shopList';
import NoSSR from 'react-no-ssr';
import Ad from '@ifeng-fe/ui_pc_ad';

class CenterNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { techTitle, techList0, shopInTech, techList1, milListAd, techRSAd, replaceShopConfig },
        } = this.props;

        return (
            <div className={styles.center_box}>
                <Chip id="170177" type="struct" title="科技标题" groupName="科技" content={techTitle}>
                    <NewsTitle size="middle" />
                </Chip>
                <Chip
                    id="225759"
                    type="recommend"
                    title="科技列表1"
                    groupName="科技"
                    content={techList0}
                    translate="handleNewsData">
                    <NewsList hasTitleImg size="long" />
                </Chip>
                {replaceShopConfig.isShow ?
                    <NoSSR>
                        <Ad content={techRSAd} styleName={styles.adBox} />
                    </NoSSR> :
                    <ShopList size="long" content={shopInTech} sourceName="shopInTech" />
                }
                <Chip
                    id="195872"
                    type="recommend"
                    title="科技列表2"
                    groupName="科技"
                    content={techList1}
                    translate="handleNewsData">
                    <NewsList size="long" ad={milListAd} />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(CenterNewsBox);
